export default "__VITE_ASSET__B$_5PVSB__"